import Markdoc from "@markdoc/markdoc";

/**
 * remove the default <article/> wrapper
 * https://github.com/markdoc/markdoc/discussions/347
 */
export const document = {
  ...Markdoc.nodes.document,
  render: "",
};
